import {getMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/notificationSettings/myCompany/clientSettings', request)
}

async function put(request) {
    return await putMethod('/api/notificationSettings/myCompany/clientSettings', request)
}

export {get, put}
